exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.active-watchlist-selector[data-v-fe864dd8] {\n\twidth: 100%;\n\tmax-width: 1590px;\n\tmargin: 0 auto;\n\theight: 35px;\n\tbackground: #ffffff;\n\tcolor: var(--q-color-dark);\n}\n", ""]);

